// // import packages and modules
// import Footer from './headfoot/Footer'
// import Header from './headfoot/Header'

// export default function About() {
//   return (
//     <>
//       <Header />
//       <div className="sm:flex items-center max-w-screen-xl">
//         <div className="sm:w-1/2 p-10">
//           <div className="image object-center text-center">
//             <img src="https://i.imgur.com/WbQnbas.png" />
//           </div>
//         </div>
//         <div className="sm:w-1/2 p-5">
//           <div className="text">
//             <span className="text-gray-500 border-b-2 border-indigo-600 uppercase">
//               About us
//             </span>
//             <h2 className="my-4 font-bold text-3xl  sm:text-4xl ">
//               About <span className="text-indigo-600">Our Company</span>
//             </h2>
//             <p className="text-gray-700">
//               Edumore is an educational website. Here at Edumore, we help
//               students to have their study materials in video and text in one
//               place. Studying has always been easier with Edumore.
//             </p>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   )
// }
import { motion } from "framer-motion"

export default function About() {
  return (
    <section id="about" className="bg-white py-24 px-6">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-16 items-center">
        <motion.dev
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            viewport={{ once: true }}
>
            <div className="reveal">
              <h2 className="text-4xl font-bold text-[#0B1F45]">
                Your Trusted Partner in{" "}
                <span className="text-red-600">Wealth Management</span>
              </h2>
              <p className="mt-6 text-gray-600 leading-relaxed">
                Optiva Capital Partners has grown to become Africa's foremost wealth
                retention specialists.
              </p>
            </div>
        </motion.dev>

        <div className="grid grid-cols-2 gap-4 reveal">
          <motion.dev
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            viewport={{ once: true }}
            className=""
>
            <StatCard number="4,000+" label="Clients Served" />
          </motion.dev>
                    <motion.dev
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.9 }}
            viewport={{ once: true }}
            className=""
>
            <StatCard number="20+" label="Global Offices" dark />
          </motion.dev>
          <motion.dev
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 1.4 }}
            viewport={{ once: true }}
            className=""
>
            <StatCard number="120+" label="Years Experience" dark />
          </motion.dev>
          <motion.dev
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 1.8}}
            viewport={{ once: true }}
            className=""
>
            <StatCard number="11+" label="Int'l Partners" />
          </motion.dev>

        </div>
      </div>
    </section>
  )
}

function StatCard({ number, label, dark }) {
  return (
    <div
      className={`p-8 min-h-40 rounded-xl text-center border ${
        dark
          ? "bg-[#0B1F45] text-red-600 border-red-600/20"
          : "bg-gray-100 text-[#0B1F45]"
      }`}
    >
      <div className="text-3xl font-bold">{number}</div>
      <div className={`text-xs uppercase tracking-widest mt-2 opacity-70 ${dark ? 'text-white' : 'text-[#0B1F45'}`}>
        {label}
      </div>
    </div>
  )
}
